import React, { useEffect } from "react";
import Page from "../../layout/Page";

const AccessibilityStatement = () => {
  useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
  return (
    <Page
      title="Accessibility Statement - Shoora"
      description=""
      keywords="telematics, AI, IoT, fleet safety, road safety, logistics"
    >
      <div className="legal-header container py-3 border-bottom border-warning ">
        <h1 className="bold text-center">Accessibility Statement</h1>
      </div>
      <div className="container">


        <p>
          <strong>Effective Date</strong>: 1st January 2025
        </p>

        <p>
        Shoora.com, a property of MashEye Infotech Pvt. Ltd., is committed to ensuring that our website is accessible to all users, including those with disabilities. We strive to provide an inclusive and user-friendly experience for everyone by meeting or exceeding the accessibility standards outlined by the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA.
        </p>

        <h4>1. Our Commitment to Accessibility</h4>
        <p>
        We are dedicated to providing a website that is accessible to all visitors, regardless of their abilities or disabilities. To achieve this, we have taken various steps to ensure that Shoora.com is usable by people with a wide range of disabilities, including those who rely on assistive technologies like screen readers, speech recognition software, or keyboard navigation.
        </p>

        <h4>2. Key Accessibility Features</h4>
        <p>
          Shoora.com includes several features designed to improve accessibility:
        </p>
        <ul className="text-dark">
          <li className="text-dark"><strong>Keyboard Navigation:</strong> Our website is navigable using a keyboard alone, allowing users to access all content and functionality without the need for a mouse.</li>
          <li className="text-dark"><strong>Screen Reader Compatibility</strong>: We strive to ensure that our website is compatible with screen readers, which convert text into speech for users with visual impairments.</li>
          <li className="text-dark"><strong>Text Alternatives for Non-Text Content:</strong> We provide alternative text (alt text) for images, graphics, and other non-text content so that users with visual impairments can understand the context through assistive technologies.</li>
          <li className="text-dark"><strong>Color Contrast and Font Size:</strong> We use high contrast colors and allow users to adjust the font size for better readability, making it easier for users with visual impairments or dyslexia to read content.</li>
          <li className="text-dark"><strong>Clear and Simple Language:</strong> We aim to provide clear and simple language throughout the website, making it easier for users with cognitive disabilities to understand the content.</li>
        </ul>

        <h4>3. Ongoing Efforts</h4>
        <p>
        Shoora.com continuously strives to improve the accessibility of our website. We are committed to identifying and addressing any issues that may arise, ensuring that our website is compliant with WCAG 2.1 guidelines. Our team regularly reviews and updates our website to improve its accessibility and to stay up-to-date with evolving standards and best practices.
        </p>

        <h4>4. Feedback and Contact Information</h4>
        <p>
        We welcome feedback on how we can further improve the accessibility of Shoora.com. If you encounter any difficulties accessing any part of the website, or if you have suggestions for improvements, please let us know. Your feedback is valuable to us in our ongoing efforts to ensure that our website is accessible to all users.
        </p>
        <p>
        You can reach us at:
        </p>
        <p>
          <strong>Shoora.com</strong> <br />A Property of MashEye Infotech Pvt.
          Ltd. <br />
          Unit 914A, 9th Floor, BPTP Park Centra, Sector - 30, Gurugram - 122002{" "}
          <br />
          Email: info@shoora.com <br />
          Phone: +91 97287 46672
        </p>
        
        <h4>5. Third-Party Content</h4>
        <p>
        While we strive to make all content on Shoora.com accessible, some third-party content and services linked on our website may not yet fully comply with accessibility standards. We encourage you to contact us if you encounter any third-party content that is inaccessible, and we will work with the relevant providers to address the issue.
        </p>

        <h4>6. Changes to This Accessibility Statement</h4>
        <p>
        We may update this Accessibility Statement periodically to reflect changes in our accessibility practices or to accommodate new standards and technologies. Please review this page periodically to stay informed about our commitment to accessibility.
        </p>
        <p>
        By using Shoora.com, you acknowledge and agree to our Accessibility Statement.
        </p>

      
      </div>
    </Page>
  );
};

export default AccessibilityStatement;
